import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { keys } from 'underscore'


export default class extends React.Component {
    static propTypes = {
		interest: PropTypes.object.isRequired,
		filters: PropTypes.object.isRequired,
		filter: PropTypes.string.isRequired
	};

    render() {

		let urlBase = this.props.interest.link;

		return (
			<p>
				{ 
					keys(this.props.filters).map(
						slug => {
							let title = this.props.filters[slug];
							return <Link to={urlBase + (slug !== 'all' ? slug : '')} key={'discover-filter-' + slug} className="no-style">
								<span className={"mright10" + (this.props.filter === slug ? ' text-mid-success' : '')}>
									{title}
								</span>
							</Link>
						}
					)
				}
			</p>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Filtered/components/ContentTypes.js